import * as React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router";

import LoggedInContainer from "web_modules/shared/LoggedInContainer";
import { loadSearchData as loadSearchDataAction } from "web_modules/redux/searchLoans/actions";
import { getSessionToken } from "web_modules/shared/session";
import Homepage from "./Homepage";
import AppView from "./AppView";
import PreApprovals from "./PreApprovals";
import PreApprovalDetail from "./PreApprovals/PreApprovalDetail";

const navPaths = {
  root: "/loan-officer",
  app: "/loan-officer/app",
  preApprovals: "/loan-officer/pre-approvals",
};

class LoanOfficerDashboard extends React.Component<any, any> {
  componentDidMount() {
    const { loadSearchData } = this.props;
    if (getSessionToken()) {
      loadSearchData();
    }
  }

  render() {
    return (
      <LoggedInContainer
        titleLink={{
          name: "Loan Officer",
          to: navPaths.root,
        }}
        headerLinks={[
          {
            name: "Loans",
            to: navPaths.root,
            pathIsCurrentPage: (path: string) =>
              path === navPaths.root ||
              path === `${navPaths.root}/` ||
              path.startsWith(navPaths.app),
          },
          {
            name: "Pre-approvals",
            to: navPaths.preApprovals,
          },
        ]}
      >
        <Switch>
          <Route exact path="/loan-officer" component={Homepage} />
          <Route exact path="/loan-officer/app/:appID" component={AppView} />
          <Route exact path="/loan-officer/pre-approvals" component={PreApprovals} />
          <Route
            exact
            path="/loan-officer/pre-approvals/:preapprovalID"
            component={PreApprovalDetail}
          />
        </Switch>
      </LoggedInContainer>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.operator.loading,
});

export default connect(
  mapStateToProps,
  { loadSearchData: loadSearchDataAction },
)(LoanOfficerDashboard);
